import {buildASTSchema, print, parse} from 'graphql';
import {mergeTypeDefs} from '@graphql-tools/merge';

import {typeDefs as cmsBaseTypeDefs} from './cmsBaseSchema';
import {typeDefs as cmsMultiItemTypeDefs} from './cmsMultiItemSchema';
import {typeDefs as ecommerceTypeDefs} from './ecommerceSchema';
import {typeDefs as rootTypeDefs} from './rootSchema';
import {typeDefs as siteInfoTypeDefs} from './siteInfoSchema';
import {typeDefs as siteSearchTypeDefs} from './siteSearchSchema';

export const typeDefs = mergeTypeDefs([
  rootTypeDefs,
  siteInfoTypeDefs,
  cmsBaseTypeDefs,
  cmsMultiItemTypeDefs,
  siteSearchTypeDefs,
  ecommerceTypeDefs,
]);

// Non-executable schema for validation purposes
export const schema = buildASTSchema(typeDefs);

/**
 * Non-executable schema for legacy GraphQL endpoint
 * Makes a copy to ensure `schema` is not affected.
 */
export const sharedLeanSchema = buildASTSchema(
  mergeTypeDefs([
    parse(print(rootTypeDefs)),
    parse(print(cmsBaseTypeDefs)),
    parse(print(ecommerceTypeDefs)),
  ])
);
